import { staticConfig } from "@fidget/common/config/static-config";

export const isOrangeOrg = (orgId: string) => {
  return orgId === staticConfig.orangeOrgId;
};
